import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useTalkingPoints } from '../../api';
import type { TalkingPointDto } from '../../api/generated/client';
import { AdminContentScreen, TalkingPointEditor } from '../../components/admin';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { AVAILABLE_LANGUAGES } from '../../i18n/i18nextInit';

const emptyPoint: TalkingPointDto = {
    excludedDomiciles: [],
    includedDomiciles: [],
    global: false,
    key: '',
    id: -1,
    order: 0,
    name: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    description: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
};

export const AdminTalkingPoints: FunctionComponent = () => {
    const { data: talkingPoints } = useTalkingPoints();

    const [talkingPointId, setSearchParams] = useNumberSearchParams('point');
    const displayedItem = useMemo(
        () => (talkingPointId != null ? talkingPoints?.find((p) => p.id === talkingPointId) || emptyPoint : undefined),
        [talkingPointId, talkingPoints],
    );

    const goToTalkingPoint = (pointId: number) => setSearchParams({ point: pointId.toString() });

    return (
        <AdminContentScreen
            items={talkingPoints}
            displayedItem={displayedItem}
            onCreateClick={() => goToTalkingPoint(-1)}
            onItemClick={goToTalkingPoint}
            itemEditorComponent={<TalkingPointEditor point={displayedItem} key={talkingPointId} />}
        />
    );
};
